import React, { useState, useEffect } from 'react';
import { Dialog, Paper, Grid, withStyles } from '@material-ui/core';
import TypicalProblemForm, {types, updateKey} from './TypicalProblemForm'
import * as Yup from "yup";
import { parseURL } from "../../sc-utilities";
import { BackButton, hasPermission } from '../../sc-utilities';
import * as actions from './store/typicalProblemActions';
import { connect } from "react-redux";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }

});

const TypicalProblemEdit = props => {
    const { classes, typicalProblem, activeCustomer, translations, permissions, onEditTypicalProblem, onFetchTypicalProblem, onFetchGrades, onFetchGradingCategories } = props;

    const [data, setData] = useState({
        grades: [],
        gradingCategories: [],
        types: [],
        key: null,
        loadingData: true
    });

    useEffect(() => {
        const fetchData = async () => {
            await onFetchTypicalProblem({ TypicalProblemID: parseURL(window.location.href).typicalProblemID, ActiveCustomerID: activeCustomer });
            let gradeData = await onFetchGrades({ ActiveCustomerID: activeCustomer });
            let gradingCategoryData = await onFetchGradingCategories({ ActiveCustomerID: activeCustomer });

            setData({
                grades: gradeData,
                gradingCategories: gradingCategoryData,
                types: types,
                loadingData: false
            });
        };
        fetchData();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data.grades.length === 0) {
        data.grades.push({ value: "grades_none", displayValue: "None" });
    }

    if (data.gradingCategories.length === 0) {
        data.gradingCategories.push({ value: "gradingCategories_none", displayValue: "None" });
    }

    if (data.types.length === 0) {
        data.types.push({ value: "types_none", displayValue: "None" });
    }

    const handleSubmit = async data => {
        let objestToSend = {...data};
        if (objestToSend["GradeID"] === "grades_none") {
            objestToSend["GradeID"] = null;
        }
        if (objestToSend["GradingCategoryID"] === "gradingCategories_none") {
            objestToSend["GradingCategoryID"] = null;
        }
        if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
            objestToSend["Key"] = null;
        }
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        objestToSend['TypicalProblemID'] = typicalProblem.TypicalProblemID;
        let result = await onEditTypicalProblem({ ...objestToSend, ActiveCustomerID: activeCustomer });

        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        Name: typicalProblem ? typicalProblem.Name : '',
        LongName: typicalProblem ? typicalProblem.LongName : '',
        Code: typicalProblem ? typicalProblem.Code : '',
        GradeID: typicalProblem ? typicalProblem.GradeID : data.grades && data.grades.length > 0 ? data.grades[0].value : '',
        GradingCategoryID: typicalProblem ? typicalProblem.GradingCategoryID : data.gradingCategories && data.gradingCategories.length > 0 ? String(data.gradingCategories[0].value) : '',
        CustomerID: typicalProblem?.CustomerID ? "custom"   :   "system",
        Key: typicalProblem?.Key ? typicalProblem.Key : typicalProblem.Name && typicalProblem?.CustomerID ? updateKey(typicalProblem.Name) : '',
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            LongName: Yup.string().required("Required"),
            Code: Yup.string().required("Required"),
            GradeID: Yup.string().required("Required"),
            GradingCategoryID: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required"),
            Key: Yup.string().when("CustomerID", {
                is: "system",
                then: Yup.string().required()
            })
        },
        FormTitle: translations['edit_typical_problem'] || "Edit typical problem",
        ButtonSubmit: hasPermission(permissions, "system_typical_problem_save") ||
        (hasPermission(permissions, "typical_problem_save") && typicalProblem.CustomerID)
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    {!data.loadingData ?
                        <TypicalProblemForm
                            formSettings={formSettings}
                            initialValues={initialValues}
                            grades={data.grades}
                            handleSubmit={handleSubmit}
                            gradingCategories={data.gradingCategories}
                            types={data.types}
                            create={true}
                            translations={translations}
                            permissions={permissions}
                            CustomerIDPreviousState={typicalProblem?.CustomerID ? 'custom'   :   'system'}
                            fromEdit={true}
                        />
                        : null}
                </Grid>
            </Grid>
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        typicalProblem: state.setting.typicalProblems && state.setting.typicalProblems.loaded ? state.setting.typicalProblems.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditTypicalProblem: typicalProblem => dispatch(actions.editTypicalProblem(typicalProblem)),
        onFetchTypicalProblem: typicalProblem => dispatch(actions.loadTypicalProblem(typicalProblem)),
        onFetchGrades: (id) => dispatch(actions.fetchGrades(id)),
        onFetchGradingCategories: (id) => dispatch(actions.fetchGradingCategories(id))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TypicalProblemEdit));

